import { useState, useEffect } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'

import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, Label } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'

import BaseDialog from "@/components/dialog/BaseDialog";
import { TablePagination } from "@/components/holders/TablePagination";

import { QuestionMarkCircleIcon } from '@heroicons/react/16/solid'
import { useForm, SubmitHandler } from "react-hook-form"

import store from "@/redux/store";
import {companyKvKCheck} from '@/reducers/CustomerCheck';


export function Search({ ...props }) {
    const [items, setItems] = useState([]);
    const [pagination, setPagination] = useState();
  const { register, handleSubmit, watch, reset,    formState, setValue, getValues } = useForm({
      defaultValues: ((props?.item) ? {...props?.item} : {})
      //values: props.data
    })
    const searchDataAPI = async (data) => {
       var promise = await store.dispatch(  companyKvKCheck(data) ).then((data) => {
           
           if(data.payload.data.items) {
               setItems(data.payload.data.items);
           }
           if(data.payload.data.pagination) {
               setPagination(data.payload.data.pagination);
           }
           
           
       });
        return promise;
    }
   const onSubmit: SubmitHandler<any> = (data) => {
       searchDataAPI(data);
//       store.dispatch(  companyKvKCheck(data) ).then((data) => {
 //          
  //     });
    if(props?.onSaveHandler) {
        props?.onSaveHandler(data);
        
    }
      
    return false;

    }

    const prevPageEvent = (pagination) => {
        setValue('page', pagination.current_page-1);
        onSubmit(getValues());
    }
    
    const nextPageEvent = (pagination) => {
        setValue('page', pagination.current_page+1);
        onSubmit(getValues());
    }
    
    const searchKvK= (event) => {
        
    }    

    return (
        <>
        <BaseDialog {...props} nofooter>


            <div className="flex flex-col ">
            <div className="h-10">
                <h1>Zoek bedrijf informatie via KVK</h1>
            </div>
            <div className="">
            <form className="w-full grid grid-cols-12 gap-2 " onSubmit={handleSubmit(onSubmit)}>
            
    <div className="col-span-3">
      <label htmlFor="account-number" className="block text-sm/6 font-medium text-gray-900">
        KvK nummer
      </label>
      <div className="mt-2 grid grid-cols-1">
        <input
          id="kvkNumber"
          name="kvkNumber"
          type="text"
          placeholder="000000000"
          {...register("kvkNumber")}
          className="col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pl-3 pr-10 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:pr-9 sm:text-sm/6"
        />
        <QuestionMarkCircleIcon
          aria-hidden="true"
          className="pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-gray-400 sm:size-4"
        />
      </div>
    </div>            

    <div className="col-span-3">
      <label htmlFor="account-number" className="block text-sm/6 font-medium text-gray-900">
        Bedrijfsnaam
      </label>
      <div className="mt-2 grid grid-cols-1">
        <input
          id="companyName"
          name="companyName"
          type="text"
          placeholder="Bedrijfsnaam"
          {...register("companyName")}
          className="col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pl-3 pr-10 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:pr-9 sm:text-sm/6"
        />
        <QuestionMarkCircleIcon
          aria-hidden="true"
          className="pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-gray-400 sm:size-4"
        />
      </div>
    </div>            

    <div className="col-span-3">


        <button
            onClick={(event) => {searchKvK(event)}}  
          type="submit"
          className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
            Zoeken
        </button>


    </div>            
    </form>
            </div>
            <div className="overflow-x-hidden overflow-y-auto grow">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Naam
                  </th>
                  <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                    <span className="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              
              <tbody className="divide-y divide-gray-200">
                {items && items.map((item) => (
                  <tr key={item.vestigingsnummer}>
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                            {item.kvkNummer}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{item.naam}<br/>
                    <div>
                        {item?.adres?.binnenlandsAdres?.straatnaam} {item?.adres?.binnenlandsAdres?.plaats} 
                    
                    </div>
                    </td>
                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0 mr-5">

                    </td>
                  </tr>
                ))}
              </tbody>
              
              
              
            </table>
            </div>
            <TablePagination className="mt-2 h-10" data={pagination} nextPageEvent={nextPageEvent} prevPageEvent={prevPageEvent}/>
            </div>
        
        
        
        </BaseDialog>
        </>
    )
    
}
    
